import * as React from 'react';
import { History } from 'history';
import Model from './region-model';
import BasePicklist from '../base/base-picklist.component';

interface IProps { 
  history: History;
  currentId?: number;  
  caption?: string;  
  parentId?: number;  
  regionType?: string;  
  onLoad?: (data: any) => void;
}

interface IState {
}

export default class RegionPicklist extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);
  }



  public render(): React.ReactNode {
    return (
      <BasePicklist history={this.props.history} caption={this.props.caption} endPointFilter={Model.endPointFilterList(this.props.parentId, this.props.regionType)} model={Model} currentId={this.props.currentId} onLoad={this.props.onLoad} disableBackButton/>
    );
  }
}
